var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "pt-1" },
    [
      _c("h4", { staticClass: "border-bottom pb-05 mb-1" }, [
        _c("i", { staticClass: "feather icon-tag" }),
        _vm._v(" " + _vm._s(_vm.__("event.tickets.headers.event_tickets"))),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.__("event.tickets.sell")))]),
      _vm._v(" "),
      _vm._l(_vm.tickets, function (ticket, i) {
        return _c("details", { key: i }, [
          _c("summary", [
            _vm._v(
              "\n                Ticket: " +
                _vm._s(ticket.title) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "ticket_title" } },
              [_vm._v("Ticket title")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: ticket.title,
                  expression: "ticket.title",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "ticket_title[]",
                id: "ticket_title",
                required: "",
              },
              domProps: { value: ticket.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(ticket, "title", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "ticket_price" } },
              [_vm._v(_vm._s(_vm.__("event.tickets.fields.text.ticket_price")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: ticket.price,
                  expression: "ticket.price",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                name: "ticket_price[]",
                id: "ticket_price",
                min: "0",
                oninput: "validity.valid||(value='');",
                required: "",
              },
              domProps: { value: ticket.price },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(ticket, "price", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "ticket_description" } },
              [_vm._v("Ticket Description")]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: ticket.description,
                  expression: "ticket.description",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: "ticket_description[]",
                id: "ticket_description",
                required: "",
              },
              domProps: { value: ticket.description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(ticket, "description", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "ticket_qty" } },
              [_vm._v("Ticket Qty")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: ticket.qty,
                  expression: "ticket.qty",
                },
              ],
              staticClass: "form-control",
              attrs: {
                step: "1",
                type: "number",
                name: "ticket_qty[]",
                min: "0",
                oninput: "validity.valid||(value='');",
                id: "ticket_qty",
                required: "",
              },
              domProps: { value: ticket.qty },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(ticket, "qty", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          ticket.id
            ? _c("div", [
                _c("input", {
                  attrs: { type: "hidden", name: "ticket_id[]" },
                  domProps: { value: ticket.id },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-danger",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  return _vm.removeTicket(i, ticket.id ? ticket.id : 0)
                },
              },
            },
            [_vm._v(_vm._s(_vm.__("event.tickets.form.links.remove_ticket")))]
          ),
        ])
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          {
            staticClass: "btn btn-primary",
            attrs: { href: "#" },
            on: { click: _vm.addNewTicket },
          },
          [_vm._v(_vm._s(_vm.__("event.tickets.form.buttons.add_ticket")))]
        ),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "border-bottom pb-05 mb-1 pt-2" }, [
        _c("i", { staticClass: "feather icon-link" }),
        _vm._v(" " + _vm._s(_vm.__("event.link_external_site"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "contact_link" } }, [
          _vm._v(_vm._s(_vm.__("event.link_external_site_paragraph"))),
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control",
          attrs: { type: "text", name: "contact_link", id: "contact_link" },
          domProps: {
            value: _vm.event !== undefined ? _vm.event.contact_link : "",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "help-block text-muted font-small-1" }, [
          _vm._v(_vm._s(_vm.__("event.link_external_site_helper"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex pt-2 pb-1" }, [
        _c("div", { staticClass: "mr-auto form-group pb-0 mb-0" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary ml-auto js-btn-prev",
              attrs: { type: "button", title: "Create Account" },
              on: { click: _vm.scrollToTop },
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _vm._v(
                " " + _vm._s(_vm.__("globals_previous_step")) + "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group pb-0 mb-0" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary ml-auto js-btn-next",
              attrs: { type: "button", title: "Create Account" },
              on: { click: _vm.scrollToTop },
            },
            [
              _vm._v(_vm._s(_vm.__("globals.next_step")) + " "),
              _c("i", { staticClass: "fa fa-chevron-right" }),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }